import * as defaultImport from "@splunk/react-icons/enterprise/GaugeRadial";
export * from "@splunk/react-icons/enterprise/GaugeRadial";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
